<div [formGroup]="storageForm" fxLayout="row wrap" fxLayoutAlign="space-between">


  <mat-form-field fxFlex="25">

    <mat-label>Total space </mat-label>
    <input name="totalSpace" formControlName="totalSpace" [allowNegativeNumbers]="false" [mask]="'0*'" matInput>
    <span matSuffix>MB</span>

    <mat-error
      *ngIf="storageForm.controls.totalSpace?.errors?.min && !storageForm.controls.totalSpace?.errors?.required">
      Total Space must be greater or equal to {{storageForm.controls.totalSpace?.errors?.min.min}} MB
    </mat-error>
    <mat-error *ngIf="storageForm.controls.totalSpace?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <mat-form-field fxFlex="70" *ngIf="!isContextual">
    <mat-label>Testbed </mat-label>
    <mat-select formControlName="testbed" [compareWith]="testbedComparator" name="testbed">
      <mat-option *ngIf="!loadingTestbeds && testbeds.length === 0">
        No testbeds available.
      </mat-option>
      <mat-option *ngFor="let testbed of testbeds" [value]="testbed">
        {{testbed.company?.companyName ? testbed.company?.companyName + ' - ' : ''}}{{testbed.identifier}}
      </mat-option>
    </mat-select>
    <span *ngIf="loadingTestbeds" matPrefix><i class="fas fa-spinner fa-spin color-primary"></i>&nbsp;</span>
    <mat-hint *ngIf="!loadingTestbeds && testbeds.length === 0" class="color-warn">
      No testbeds available.
    </mat-hint>
  </mat-form-field>

  <div fxFlex="100" fxLayout="row" fxLayoutAlign="end">
    <button (click)="storage = _storage; canceled.emit()" mat-button>Cancel</button>
    <button (click)="saveStorage()" [disabled]="storageForm.invalid || saving " color="primary" mat-button>
      <i *ngIf="saving" class="fas fa-spinner fa-spin"></i>
      <ng-container *ngIf="!saving">Save</ng-container>
    </button>
  </div>

</div>